<template>
  <div>
    <div class="title"> 문제 번호 </div>
    <mdb-btn class="p-1 m-1" v-for="i in questions.length" :color="color(i-1)"
      :key="i" style="width:30px" @click="num=(i-1)">{{i}}</mdb-btn><br/>

    <div class="text-center mt-3">
      <mdb-btn class="py-2" @click="num -= 1" :disabled="num===0">
        <mdb-icon icon="chevron-circle-left"/> 이전 문제
      </mdb-btn>
      <mdb-btn  class="py-2" @click="num += 1" :disabled="num===(questions.length-1)">
        다음 문제 <mdb-icon icon="chevron-circle-right"/>
      </mdb-btn>
    </div>

    <question :num="num" :question="questions[num]" v-model="answers[num].answer"/>

    <div class="text-center">
      <mdb-btn icon="share-square" color="primary" :disabled="!isOk" @click="$emit('save-test')"> 제출</mdb-btn>
    </div>
</div>
</template>
<script>
import Question from '../Question'
export default {
  name: 'PreWritingTest',
  components: { Question },
  props: ['questions', 'answers'],
  computed: {
    isOk () {
      return this.answers.every(a => a !== 0)
    }
  },
  data: () => ({
    num: 0,
    question: undefined
  }),
  methods: {
    color (i) {
      if (i === this.num) return 'warning'
      else if (this.answers[i].answer && (this.answers[i].answer !== 0)) return 'success'
      return 'red'
    }
  },
  watch: {
  }
}
</script>
